exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".view-title-root {\n  font-size: 20px;\n  padding-left: 10px;\n  margin: 0px 0 20px 0; }\n  .view-title-root .view-title-left {\n    margin-top: 3px; }\n    .view-title-root .view-title-left.view-title-left-model-detail {\n      margin-top: 4px; }\n", ""]);

